import {
  // added cp approve
  ADD_CHANNEL_PARTNER,
  CHANNEL_PARTNER_DETAIL,
  CHANNEL_PARTNER_ERROR,
  CHANNEL_PARTNER_FILTER,
  CHANNEL_PARTNER_LIST,
  CHANNEL_PARTNER_STATUS,
  CP_CURRENT_MAPING,
  CHANNEL_PARTNER_APPROVE,
  ADD_CP_TO_BUCKET,
  REMOVE_BUCKETDATA,
  REMOVE_CHECK_EMAIL_MOBILE,
  UPDATE_CHANNEL_PARTNER,
  CP_LIST_FOR_SM,
} from "reduxStore/types";
import { CHECK_EMAIL_MOBILE, GET_SM_LIST } from "../types";

const initialState = {
  response: null,
  loading: true,
  create: false,
  detail: false,
  update: false,
  edit: true,
};
const initialStateSMlist = {
  response: null,
  loading: true,
  create: false,
  detail: false,
};
const intialStateCPMaping = {
  response: null,
  loading: true,
  create: false,
  detail: false,
};
const initialStateForm = {
  response: null,
  update: false,
};

const initialCpSMList = {
  response: null,
  loading: true,
  detail: false,
  update: false,
};
export default function channelPartnerStore(state = initialState, action) {
  switch (action.type) {
    case CHANNEL_PARTNER_LIST:
      return {
        ...state,
        loading: false,
        create: false,
        detail: false,
        response: action.payload,
      };
    case CHANNEL_PARTNER_DETAIL:
      return {
        ...state,
        loading: false,
        create: false,
        detail: true,
        response: action.payload,
      };
    case CHANNEL_PARTNER_FILTER:
      return {
        ...state,
        create: false,
        detail: false,
        response: action.payload,
      };
    case CHANNEL_PARTNER_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };
    case CHANNEL_PARTNER_STATUS:
      return {
        ...state,
        create: true,
        detail: false,
        userData: action.payload,
      };
    case ADD_CHANNEL_PARTNER:
      return {
        ...state,
        create: true,
        detail: false,
        userData: action.payload,
      };
    case UPDATE_CHANNEL_PARTNER:
      return {
        ...state,
        edit: true,
        userData: action.payload,
      };
    case CHANNEL_PARTNER_APPROVE:
      return {
        ...state,
        create: true,
        detail: false,
        userData: action.payload,
      };
    case ADD_CP_TO_BUCKET:
      return {
        ...state,
        update: true,
        response: action.payload,
      };
    case REMOVE_BUCKETDATA:
      return {
        ...state,
        update: false,
        response: null,
      };
    default:
      return state;
  }
}
export function getCPCurrentMapingData(state = intialStateCPMaping, action) {
  switch (action.type) {
    case CP_CURRENT_MAPING:
      return {
        ...state,
        loading: false,
        create: false,
        detail: false,
        response: action.payload,
      };
    default:
      return state;
  }
}
export function geSMlistReducer(state = initialStateSMlist, action) {
  switch (action.type) {
    case GET_SM_LIST:
      return {
        ...state,
        loading: false,
        create: false,
        detail: false,
        response: action.payload,
      };
    default:
      return state;
  }
}

// employee_Email_Mobile_number_check
export function employeeEmailMobileCheck(state = initialStateForm, action) {
  switch (action.type) {
    case CHECK_EMAIL_MOBILE:
      return {
        ...state,
        update: true,
        response: action.payload,
      };
    case REMOVE_CHECK_EMAIL_MOBILE:
      return {
        ...state,
        update: false,
        response: action.payload,
      };
    default:
      return state;
  }
}

export function cpSmstore(state = initialCpSMList, action) {
  switch (action.type) {
    case CP_LIST_FOR_SM:
      return {
        ...state,
        loading: false,
        update: false,
        detail: false,
        response: action.payload,
      };

    default:
      return state;
  }
}
